<ng-container appOutlet></ng-container>
